import { AuthProvider } from '@asgardeo/auth-react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { asgardeoConfig } from './services/asgardeoConfig';
import { CreditProvider } from './config/creditContext'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider config={asgardeoConfig}>
        <CreditProvider>
          <App />
        </CreditProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
